// extracted by mini-css-extract-plugin
module.exports = {"Template":"styles_Template__25H3R","ButtonContainer":"styles_ButtonContainer__DVDDF"};